export const API_PATH_apiUsersInvitationsUndeletePut = '/services/users-invitations/undelete';
